export default "__VITE_PUBLIC_ASSET__39982a2b__"